import EastIcon from "@mui/icons-material/East";
import {
  Box,
  Button,
  Checkbox,
  Container,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  Stack,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { setCookie } from "../../../Cookies";
import { functions } from "../../../Firebase";
import classes from "../../styles/LoginpageStyle/LoginPage.module.css";
import FacebookIcon from "./FacebookIcon.svg";
import InstagramIcon from "./InstagramIcon.svg";
import LinkedinIcon from "./LinkedinIcon.svg";
import LoginFooterLogo from "./Serein Platform Logos/serein-logo-white.svg";
import loginImg1 from "./login-img-01.png";
import loginImg2 from "./login-img-02.png";
import loginLogo from "./login-logo.png";
import "./login.css";
import quote from "./quote.png";
import login_page from "./Serein Platform Logos/PlatformheroImage.png";

import { IP } from "../../../baseUrlAndConfig";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import axios from "axios";
import { httpsCallable } from "firebase/functions";
import { displayOnDesktop } from "../../../utilities/commonStyles/commonStyles";

import Marquee from "react-easy-marquee";
import { useDispatch } from "react-redux";
import { supportLogger } from "../../../supportLoggerFunction";
import { DrawerContext } from "../../../utilities/context/DrawerProvider";
import img1 from "./drive/1.png";
import img10 from "./drive/10.png";
import img11 from "./drive/11.png";
import img12 from "./drive/12.png";
import img13 from "./drive/13.png";
import img14 from "./drive/14.png";
import img15 from "./drive/15.png";
import img16 from "./drive/16.png";
import img18 from "./drive/18.png";
import img19 from "./drive/19.png";
import img2 from "./drive/2.png";
import img20 from "./drive/20.png";
import img21 from "./drive/21.png";
import img22 from "./drive/22.png";
import img23 from "./drive/23.png";
import img24 from "./drive/24.png";
import img25 from "./drive/25.png";
import img27 from "./drive/27.png";
import img28 from "./drive/28.png";
import img29 from "./drive/29.png";
import img3 from "./drive/3.png";
import img30 from "./drive/30.png";
import img4 from "./drive/4.png";
import img5 from "./drive/5.png";
import img6 from "./drive/6.png";
import img7 from "./drive/7.png";
import img8 from "./drive/8.png";
import img9 from "./drive/9.png";
import { Mail, MailOutline } from "@material-ui/icons";
import { EmailIcon } from "./svg/email";
import { LocationIcon } from "./svg/location";
import newimg2 from "./Withpadding/div-1.svg";
import newimg3 from "./Withpadding/div-2.svg";
import newimg4 from "./Withpadding/div-3.svg";
import newimg5 from "./Withpadding/div-4.svg";
import newimg6 from "./Withpadding/div-5.svg";
import newimg7 from "./Withpadding/div-6.svg";
import newimg8 from "./Withpadding/div-7.svg";
import newimg9 from "./Withpadding/div-8.svg";
import newimg10 from "./Withpadding/div-9.svg";
import newimg12 from "./Withpadding/div-10.svg";
import newimg11 from "./Withpadding/div-11.svg";
import newimg1 from "./Withpadding/div.svg";

import spotisvg from "./Serein Platform Logos/Spotify_icon.svg";
import sereinLogo from "./Serein Platform Logos/serein-logo.svg";
import { LinedinIcon } from "./svg/linkedin";
import { YoutubeIcon } from "./svg/youtube";
import { InstagramIco } from "./svg/instagram";
import { SpotifyLogo } from "./svg/spotify";

const images = [
  newimg1,
  newimg2,
  newimg3,
  newimg4,
  newimg5,
  newimg6,
  newimg7,
  newimg8,
  newimg9,
  newimg10,
  newimg11,
  newimg12,
];

const steps = [
  {
    img: img1,
  },
  {
    img: img2,
  },
  {
    img: img3,
  },
  {
    img: img4,
  },
  {
    img: img5,
  },
  {
    img: img6,
  },
  {
    img: img7,
  },
  {
    img: img8,
  },
  {
    img: img9,
  },

  {
    img: img10,
  },
  {
    img: img11,
  },
  {
    img: img12,
  },

  {
    img: img13,
  },
  {
    img: img14,
  },
  {
    img: img15,
  },
  {
    img: img16,
  },
  // {
  //   img: img17,
  // },
  {
    img: img18,
  },
  {
    img: img19,
  },
  {
    img: img20,
  },
  {
    img: img21,
  },
  {
    img: img22,
  },

  {
    img: img23,
  },
  {
    img: img24,
  },
  {
    img: img25,
  },

  {
    img: img27,
  },
  {
    img: img28,
  },
  {
    img: img29,
  },
  {
    img: img30,
  },
];

function LoginPage({ messagingToken }) {
  const navigate = useNavigate();
  const goToHome = () => navigate("/");
  const dispatch = useDispatch();
  const goToUserDashboard = () => navigate("/hr/Learning");
  //const goToAdminDashboard = () => navigate("/admin");
  const goToAdminDashboard = () => navigate("/admin");
  const goToHrDashboard = (rolesAndPermission) => {
    console.log(rolesAndPermission);
    for (let [key, value] of Object.entries(rolesAndPermission)) {
      if (key == "Learning" && value.viewPermission == true) {
        navigate("/hr/learning");
        return;
      }
      if (key == "Profile" || key == "Strategy") {
        continue;
      } else {
        if (value.viewPermission == true) {
          switch (key) {
            case "Psycological_Study":
              navigate("/hr/Psychological_safety");
              break;
            case "Report":
              navigate("/hr/GroupReport");
              break;
            case "Calender":
              navigate("/hr/DEI");
              break;
            default:
              console.log(key);
              navigate("/hr/HrProfilePage");
          }
        }
      }
    }
    navigate("/hr/Learning");
  };
  const goToInstructorDashboard = () => navigate("/admin");
  const fetchUserProfile = httpsCallable(functions, "fetchUserProfile");
  const updateUserProfileInvitation = httpsCallable(
    functions,
    "updateUserProfileInvitation",
  );

  // const [role, setRole] = useState("");
  const { rolesAndPermission, setRolesAndPermission } =
    useContext(DrawerContext);
  const [user, setUser] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [userNameError, setUserNameError] = useState("");
  const [userSetNotification, setUserSetNotification] = useState("");
  const [notification, setNotification] = useState("");
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [keep, setKeep] = useState(false);
  ///========visibility password=======//
  const [showPassword, setShowPassword] = useState(false);

  const clearInputs = () => {
    setUserNameError("");
    setPassword("");
    setNotification("");
  };

  const clearErrors = () => {
    setNotification("");
    setUserNameError("");
    setPasswordError("");
  };

  ///if user is logged in, redirect to user dashboard
  useEffect(() => {
    var config = {
      method: "get",

      url: `${IP}/`,
      headers: {
        "Content-Type": "application/json",
      },
      data: "data",
    };

    axios(config)
      .then((res) => {})
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const handleLogin = async () => {
    clearErrors();

    if (userName == "") {
      return setUserSetNotification("Please enter your username");
    } else if (!userName.includes("@")) {
      return setUserSetNotification("Invalid Email");
    } else {
      setUserSetNotification("");
    }
    if (password == "") {
      return setNotification("Please enter your password");
    } else {
      setNotification("");
    }
    setLoading(true);

    var data = JSON.stringify({
      email: userName.trim(),
      password: password,
    });

    // deleteCookie();
    localStorage.removeItem("bearer");
    setCookie("bearer", "");
    // deleteCookiesInServer();
    // localStorage.setItem("clrs", JSON.stringify(newGreen));
    var config = {
      method: "post",

      url: `${IP}/auth/signIn`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(async function (response) {
        let userCredential = response.data;
        // console.log(userCredential);
        let temp = {
          email: userName,
          ui: userCredential?.uiPermission,
        };
        supportLogger(temp);

        setRolesAndPermission(userCredential.uiPermission);

        setCookie("bearer", userCredential.idToken);
        setCookie("rfToken", JSON.stringify(userCredential.refreshToken));
        setCookie("exp", Date.now() / 1000 + 1800);
        // saveToken({ token: messagingToken });

        let data = JSON.stringify({});

        var config = {
          method: "get",

          url: `${IP}/userProfile`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userCredential.idToken}`,
          },
          data: data,
        };
        axios(config)
          .then((res) => {
            let resObj = res.data.message;
            setCookie("ROLE", resObj.role);

            setCookie("EMNAME", resObj.name);
            setCookie("keepMeLogin", keep);
            let role = resObj.role;
            localStorage.setItem("idc", resObj.companyId);
            setLoading(false);
            if (role == "ADMIN") goToAdminDashboard();
            else if (role == "HR") goToHrDashboard(userCredential.uiPermission);
            else if (role == "USER") goToUserDashboard();
            else {
              navigate("/hr/HrProfilePage");
            }
            // else {
            //   goToHrDashboard();
            // }
          })
          .catch((er) => {
            // console.log(er);
          });
      })
      .catch((err) => {
        setLoading(false);
        supportLogger(err?.response);
        supportLogger(err);

        // console.log(err);
        if (err.response.data.error === "USER_DISABLED") {
          return setNotification("This user archived Please contact to serien");
        }
        if (
          err.response.data.error == "INVALID_PASSWORD"
          // err.response.data.error == "EMAIL_NOT_FOUND"
        ) {
          return setNotification("Enter valid Credentials");
        }
        if (err.response.data.error == "INVITATION_NOT_ACCEPTED") {
          return setNotification(
            "Please accept the invitation sent to your email by Serein Learning Academy -learning@serein.in.",
          );
        }
        if (err.response.data.error == "EMAIL_NOT_FOUND") {
          return setNotification("This user does not exist");
        }
        return setNotification("Something went wrong");
      });
  };

  const handleLogout = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        goToHome();
      })
      .catch((error) => {
        console.log(error.code);
        // An error happened.
      });
    //   fire.auth().signOut();
  };

  const authListener = () => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        clearInputs();
        const uid = user.uid;
        // //console.log(user.accessToken);
        setUser(user);
      } else {
        setUser("");
      }
    });
  };

  const setKipemeLog = (e) => {
    setKeep(!keep);
    ////console.log(keep)
    //  //console.log(e)
  };
  useEffect(() => {
    authListener();
  }, []);
  //console.log(keep)
  //console.log(keep)
  const deletecookies = () => {
    localStorage.removeItem("bearer");
    setCookie("bearer", "");
  };

  return (
    <Box
      // data-aos="zoom-out"
      // data-aos-duration="2000"
      sx={{
        backgroundColor: "#FFFFFF",
        height: "100dvh",
        width: "100dvw",
      }}
    >
      <Box
        sx={{
          display: "flex",
          pt: { xs: 6, md: 10 },
          gap: { xs: 8, md: 12 },
          flexDirection: "column",
          justifyContent: "space-between",
          backgroundColor: "#FFFFFF",
        }}
      >
        <Container
          maxWidth={false}
          disableGutters
          sx={{
            gap: 10,
            pl: { xs: 6, md: 18 },
            pr: { xs: 6, md: 6 },
            width: "100% !important",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: { xs: "100%", md: "60%" },
              minWidth: { xs: "100%", md: "250px" },
            }}
          >
            <Box
              sx={{
                zIndex: "1",
              }}
            >
              <Box>
                <img src={sereinLogo} />
              </Box>

              <Stack
                component="form"
                sx={{
                  marginTop: "52px",
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
                onSubmit={(e) => {
                  e.preventDefault();
                  handleLogin();
                }}
              >
                {/* Email Field */}
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Username"
                  placeholder="Username"
                  required
                  autoFocus={userName.length === 0}
                  value={userName}
                  onChange={(e) => {
                    deletecookies();
                    setUserName(e.target.value);
                  }}
                  error={Boolean(userSetNotification)}
                  helperText={userSetNotification}
                  sx={{
                    background: "#FFFFFF",
                    borderRadius: "15px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "15px",
                    },
                  }}
                />

                {/* Password Field */}
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Password"
                  placeholder="Password"
                  type={showPassword ? "text" : "password"}
                  required
                  value={password}
                  onChange={(e) => {
                    deletecookies();
                    setPassword(e.target.value);
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                        >
                          <Tooltip
                            title={
                              showPassword ? "Hide Password" : "Show Password"
                            }
                            placement="top"
                          >
                            {showPassword ? (
                              <VisibilityIcon sx={{ color: "#313131" }} />
                            ) : (
                              <VisibilityOffIcon sx={{ color: "#313131" }} />
                            )}
                          </Tooltip>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    background: "#FFFFFF",
                    borderRadius: "10px",
                    marginTop: "20px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "10px",
                    },
                  }}
                />

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: 0,
                  }}
                  margin={"0 !important"}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{
                            color: "#000000",
                            "& .MuiSvgIcon-root": { fontSize: 20 },
                          }}
                          onChange={(e) => setKipemeLog(e.target.checked)}
                        />
                      }
                    />
                    <label
                      style={{
                        fontWeight: 400,
                        color: "#000000",
                        fontSize: ".8rem",
                        marginLeft: "-20px",
                      }}
                    >
                      Remember me
                    </label>
                  </Box>
                  <Box>
                    <Link to="/forgot-password-page">
                      <Typography
                        sx={{
                          color: "#6846C7",
                          fontWeight: 400,
                          fontSize: { xs: ".8rem", md: ".8rem" },
                        }}
                      >
                        Forgot password?
                      </Typography>
                    </Link>
                  </Box>
                </Box>

                <Box>
                  {notification && (
                    <span style={{ color: "red", marginTop: "20px" }}>
                      {notification}
                    </span>
                  )}
                </Box>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                  }}
                >
                  <Box margin={"0 !important"}>
                    <Button
                      className={classes.loginBtn}
                      // onClick={handleLogin}
                      type="submit"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        fontFamily: "Manrope",
                        textTransform: "none",
                        width: "100%",
                        py: 2,
                        mt: 1,
                        borderRadius: "12px",
                        fontSize: "16px",
                        fontWeight: 600,
                        background: "#6846C7",
                        color: "#fff",
                        "&:hover": {
                          background: "#6846C7",
                        },
                      }}
                    >
                      <Box>{loading ? "Logging in ..." : "Login"}</Box>
                      <Box className={classes.loginBtnIcon}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <EastIcon />
                        </Box>
                      </Box>
                    </Button>
                  </Box>
                </div>
              </Stack>
            </Box>
          </Box>
          <Box
            className={classes.loginImgMain}
            sx={{
              ...displayOnDesktop,
              width: "70%",
              zIndex: "4",
            }}
          >
            <img
              src={login_page}
              alt=""
              style={{
                width: "100%",
                height: "100%",
                zIndex: "4",
              }}
            />
          </Box>
        </Container>
        <Box sx={{ backgroundColor: "#fff", zIndex: "1" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
              justifyContent: "space-between",
            }}
          >
            <Box
              component="table"
              sx={{
                width: "100%",
                borderCollapse: "collapse",
                tableLayout: "fixed",
              }}
            >
              <Box
                sx={{
                  display: "grid",
                  // 3 columns on mobile, 6 on desktop
                  gridTemplateColumns: {
                    xs: "repeat(3, 1fr)",
                    md: "repeat(6, 1fr)",
                  },
                  borderTop: "2px solid #001568",
                  borderLeft: "2px solid #001568",
                  width: "100%",
                  // Ensure the container doesn't cut off the image
                  overflow: "hidden",
                }}
              >
                {images.map((img, index) => {
                  // Logic to highlight rows (Calculates if the current item is in an even row)
                  // For mobile (3 cols), row = Math.floor(index / 3)
                  // For desktop (6 cols), row = Math.floor(index / 6)
                  return (
                    <Box
                      key={index}
                      sx={{
                        // Dimensions
                        height: { xs: 77, md: 140 },
                        width: "100%",

                        // Border Collapse Logic (Bottom/Right only)
                        borderRight: "2px solid #001568",
                        borderBottom: "2px solid #001568",

                        // Visual Row Indicators
                        backgroundColor: "#ffffff",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        position: "relative",
                        transition: "background-color 0.2s",

                        "&:hover": {
                          zIndex: 2,
                          outlineOffset: "-2px",
                        },
                      }}
                    >
                      <Box
                        component="img"
                        src={img}
                        alt={`img-${index}`}
                        sx={{
                          width: "100%", // Slightly larger for better visibility
                          height: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </Box>
                  );
                })}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box sx={{ backgroundColor: "#6846C7", py: "50px" }}>
        <Container
          maxWidth={false}
          disableGutters
          sx={{
            gap: 10,
            px: { xs: 6, md: 18 },
            width: "100% !important",
            display: "flex",
          }}
        >
          <Box
            className="footerResponsive"
            sx={{ display: "flex", gap: "20px" }}
          >
            <Box
              sx={{
                width: "70%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  color: "#fff",
                  fontSize: "12px",
                  fontFamily: "Manrope",
                  mt: "25px",
                  fontWeight: 300,
                }}
              >
                Unless otherwise indicated, all content on this learning
                platform is the proprietary property of Serein Inc. All
                services, design, approach, content, and research material
                (collectively, the ‘Content’) are owned and controlled by Serein
                Inc. or licensed to us, and are protected by copyright and
                trademark laws and various other intellectual property rights
                and unfair competition laws of India, foreign jurisdictions and
                international conventions. No part of this platform’s content
                may be copied, reproduced, aggregated, republished, uploaded,
                posted, publicly displayed, encoded, translated, transmitted,
                distributed, sold, licensed, or otherwise exploited for any
                external website, posts, articles, or commercial purpose
                whatsoever, without prior written permission from Serein Inc.
              </Box>
              <Box
                sx={{
                  color: "#fff",
                  fontSize: "14px",
                  fontFamily: "Manrope",
                  mt: "25px",
                  fontWeight: 400,
                }}
              >
                © Serein Inc. Copyright {new Date().getFullYear()} Privacy
                Policy
              </Box>
            </Box>
            <Box
              sx={{ width: "5%", display: "flex", justifyContent: "center" }}
            >
              <Divider
                orientation="vertical"
                sx={{
                  backgroundColor: "#fff",
                  width: "1.4px",
                  opacity: "0.6",
                }}
              />
            </Box>
            <Stack
              spacing={3}
              sx={{
                width: "25%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Box>
                <img src={LoginFooterLogo} />
              </Box>

              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {" "}
                <Box sx={{ display: "flex", gap: 2 }}>
                  <EmailIcon />
                  <a
                    href="mailto:hello@serein.in"
                    style={{ color: "white", fontWeight: 400 }}
                  >
                    hello@serein.in
                  </a>
                </Box>
                <Box sx={{ display: "flex", gap: 2 }}>
                  <LocationIcon />
                  <Typography
                    sx={{
                      color: "white",
                      fontWeight: 300,
                      fontSize: { xs: "12px", md: "14px" },
                    }}
                  >
                    Serein Technologies Limited
                    <br />
                    128, City Road, London, United Kingdom
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", gap: 2 }}>
                  <LocationIcon />
                  <Typography
                    sx={{
                      color: "white",
                      fontWeight: 300,
                      fontSize: { xs: "12px", md: "14px" },
                    }}
                  >
                    Sade Global Technologies Private Limited <br />
                    442, 8th Main, Bangalore, KA 560034
                  </Typography>
                </Box>
                <Stack
                  spacing={3}
                  sx={{
                    width: "25%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "30px",
                    }}
                  >
                    <a
                      href="https://www.linkedin.com/company/serein/"
                      target="_blank"
                    >
                      <LinedinIcon />
                    </a>
                    <a
                      href="https://www.youtube.com/@sereininc"
                      target="_blank"
                    >
                      <YoutubeIcon />
                    </a>
                    <a
                      href="https://open.spotify.com/show/35cHLGW3IMLGcS6ShAUXEX?si=OJzCGzp8RtWnJHvcpWX__Q&nd=1&dlsi=6c7d3a1f734c4889"
                      target="_blank"
                    >
                      <img
                        src={spotisvg}
                        alt="Spotify"
                        width={20}
                        height={20}
                      />
                    </a>
                    <a
                      href=" https://www.instagram.com/sereininc?igsh=OXhkdHBoYzZydW4%3D"
                      target="_blank"
                    >
                      <InstagramIco />
                    </a>
                    <a
                      href="https://www.facebook.com/sereininc/"
                      target="_blank"
                    >
                      <img src={FacebookIcon} />
                    </a>
                  </Box>
                </Stack>
              </Box>
            </Stack>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}

export default LoginPage;

/* <div className="loginpage">
  <div className="loginpage-main">
    <div className="loginpage-main-left">
      <div className="loginpage-main-left-cnt">
        <div className="loginpage-main-left-cnt-items">
          <div className="loginpage-main-left-cnt-items-text-1">Log in</div>
          <div className="loginpage-main-left-cnt-items-text-2">
            Log in with your credentials provided by admin
          </div>
          <div className="loginpage-main-left-cnt-items-text-3">
            Enter Your Username
          </div>
          <div className="loginpage-main-left-cnt-items-input">
            <input type="text" placeholder="name@domain.com" required
              value={userName}
              onChange={(e) => setUserName(e.target.value)} />
            <p className="errorMsg">{userNameError}</p>
          </div>
          <div className="loginpage-main-left-cnt-items-text-4">
            Enter Your Password
          </div>
          <div className="loginpage-main-left-cnt-items-input">
            <input type="password" placeholder="At least 8 charactor" required
              value={password}
              onChange={(e) => setPassword(e.target.value)} />
            <p className="errorMsg"> {passwordError}</p>
          </div>
          <div className="loginpage-main-left-cnt-items-text-5">
            <FormControlLabel
              control={<Checkbox color="success" />}
              label="Keep me logged in"
            />
          </div>
          <div className="loginpage-main-left-cnt-items-login-btn">
            <button onClick={handleLogin}>Log in</button>
          </div>
          <div className="loginpage-main-left-cnt-items-text-6">
            Forgot Password?
          </div>
        </div>
      </div>
    </div>
    <div className="loginpage-main-right">
      <div className="loginpage-main-right-cnt">
        <img src={loginImg} alt="loading" />
      </div>
    </div>
  </div>
</div> */
